import React, { useState, useEffect } from 'react';
import './Contact.css';
import { useLanguage } from './Contexts/LanguageContext';  // Importeer de hook

// Importeer de SVG-bestanden voor social media iconen
import FacebookIcon from './assets/icons/facebook.svg';
import InstagramIcon from './assets/icons/instagram.svg';
import LinkedInIcon from './assets/icons/linkedin.svg';

function Contact() {
    const { language } = useLanguage();  // Verkrijg de huidige taal
    const [formData, setFormData] = useState({
        title: '',
        name: '',
        email: '',
        phone: '',
        countryCode: '',
        message: '',
        contactPreference: 'email',
    });
    const [showConfirmation, setShowConfirmation] = useState(false); // Om de pop-up te tonen
    const [isSubmitted, setIsSubmitted] = useState(false); // Om te controleren of het formulier is verzonden

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setShowConfirmation(true); // Toon de bevestigingspop-up
    };

    const handleConfirmation = () => {
        // Zodra de gebruiker akkoord gaat, wordt de formulier verzonden
        setIsSubmitted(true);
        setShowConfirmation(false);
        alert(language === 'nl' ? 'Bericht verzonden!' : 'Message sent!');
    };

    useEffect(() => {
        const selectElement = document.getElementById('countryCode');

        // Functie om de breedte van de dropdown aan te passen
        const adjustDropdownWidth = () => {
            const selectedOption = selectElement.options[selectElement.selectedIndex];
            const width = selectedOption.text.length * 10; // Bereken breedte op basis van lengte van de tekst
            selectElement.style.width = `${width}px`; // Pas de breedte aan
        };

        // Pas de breedte aan wanneer de component wordt geladen
        adjustDropdownWidth();

        // Pas de breedte aan wanneer de gebruiker een optie kiest
        selectElement.addEventListener('change', adjustDropdownWidth);

        // Opruimen van de event listener wanneer de component wordt ontmanteld
        return () => {
            selectElement.removeEventListener('change', adjustDropdownWidth);
        };
    }, []);

    return (
        <div className="contact-container">
            <h2>{language === 'nl' ? 'Contacteer Mij' : 'Contact Me'}</h2>
            <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                    <label htmlFor="name">{language === 'nl' ? 'Naam' : 'Name'}</label>
                    <div className="title-name-container">
                        <select
                            id="title"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            required
                        >
                            <option value="Mr.">Mr.</option>
                            <option value="Ms.">Ms.</option>
                            <option value="Dr.">Dr.</option>
                        </select>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                <div className="form-group form-group-inline">
                    <div className="email-group">
                        <label htmlFor="email">{language === 'nl' ? 'E-mail' : 'Email'}</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="phone-group">
                        <label htmlFor="phone">{language === 'nl' ? 'Mobiele Nummer' : 'Phone Number'}</label>
                        <div className="phone-input-container">
                            <select
                                id="countryCode"
                                name="countryCode"
                                value={formData.countryCode}
                                onChange={handleChange}
                                required
                            >
                                <option value="+1">+1 (US/Canada)</option>
                                <option value="+44">+44 (UK)</option>
                                <option value="+31">+31 (NL)</option>
                                <option value="+49">+49 (Germany)</option>
                                <option value="+33">+33 (France)</option>
                                <option value="+34">+34 (Spain)</option>
                                <option value="+39">+39 (Italy)</option>
                                <option value="+41">+41 (Switzerland)</option>
                                <option value="+43">+43 (Austria)</option>
                                <option value="+36">+36 (Hungary)</option>
                                <option value="+48">+48 (Poland)</option>
                                <option value="+61">+61 (Australia)</option>
                                <option value="+55">+55 (Brazil)</option>
                                <option value="+81">+81 (Japan)</option>
                                <option value="+86">+86 (China)</option>
                                <option value="+91">+91 (India)</option>
                                <option value="+972">+972 (Israel)</option>
                                <option value="+27">+27 (South Africa)</option>
                                <option value="+20">+20 (Egypt)</option>
                                <option value="+965">+965 (Kuwait)</option>
                                <option value="+971">+971 (UAE)</option>
                            </select>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="message">{language === 'nl' ? 'Bericht' : 'Message'}</label>
                    <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    ></textarea>
                </div>

                <button type="submit" className="submit-btn">{language === 'nl' ? 'Verstuur' : 'Send'}</button>
            </form>

            {/* Pop-up bevestiging */}
            {showConfirmation && (
                <div className="confirmation-popup">
                    <div className="popup-content">
                        <h3>{language === 'nl' ? 'Bevestiging' : 'Confirmation'}</h3>
                        <p>{language === 'nl' ? 'Door akkoord te gaan, worden uw gegevens verwerkt word er spoedig contact met u opgenomen.' : 'By agreeing, your data will be processed and we will contact you soon.'}</p>

                        <label>
                            {language === 'nl' ? 'Voorkeur voor contact via:' : 'Preferred contact method:'}
                        </label>
                        <select
                            name="contactPreference"
                            value={formData.contactPreference}
                            onChange={handleChange}
                        >
                            <option value="email">{language === 'nl' ? 'E-mail' : 'Email'}</option>
                            <option value="phone">{language === 'nl' ? 'Telefoon' : 'Phone'}</option>
                        </select>
                        <button onClick={handleConfirmation} className="confirm-btn">{language === 'nl' ? 'Akkoord' : 'Agree'}</button>
                    </div>
                </div>
            )}

            {/* Social media iconen */}
            <div className="social-icons">
                <a href="https://www.facebook.com/valentino.dossantos.7" target="_blank" rel="noopener noreferrer">
                    <img src={FacebookIcon} alt="Facebook" className="social-icon" />
                </a>
                <a href="https://www.instagram.com/mightylion23" target="_blank" rel="noopener noreferrer">
                    <img src={InstagramIcon} alt="Instagram" className="social-icon" />
                </a>
                <a href="https://www.linkedin.com/in/valentino-dos-santos-52044b234/" target="_blank" rel="noopener noreferrer">
                    <img src={LinkedInIcon} alt="LinkedIn" className="social-icon" />
                </a>
            </div>
        </div>
    );
}

export default Contact;
